import React from "react";
import Subtitle from "@radarly/components/cards/card/subtitle";
import { DateMetricCard } from "@radarly/models/cards";
import { DatavizLineChart } from "@radarly/models/dataviz";
import Date from "@radarly/shared/cards/subtitle/date";
import Tile from "@radarly/shared/cards/tile";
import LineChart from "@radarly/shared/widgets/date-metric/line-chart";
import { CardFragmentsProps } from "../model";

const RadarlyMetricCardLinechart = ({
  title,
  fragments,
  project,
  dataviz,
  height,
  onClickItem,
  onGenerateCSV,
  timezone,
  forceReload,
  nowDate,
}: CardFragmentsProps<DateMetricCard["fragments"], DatavizLineChart>) => {
  const fragment = fragments[0];
  return (
    <Tile
      title={title}
      height={height}
      subtitle={
        <Subtitle
          meta={[
            <Date fragment={fragment} timezone={timezone} nowDate={nowDate} />,
          ]}
        />
      }
      clause={fragment.request.query}
      onGenerateCSV={onGenerateCSV}
      isPNG
    >
      <LineChart
        fragment={fragments[0]}
        evolutionFragment={fragments[1]}
        project={project.id}
        dataviz={dataviz}
        onClickPoint={onClickItem}
        forceReload={forceReload}
        nowDate={nowDate}
      />
    </Tile>
  );
};

export default RadarlyMetricCardLinechart;
